exports.AG_GRID_LICENSE_KEY =
  "CompanyName=IRESS LIMITED,LicensedGroup=XPLAN,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=15,LicensedProductionInstancesCount=-1,AssetReference=AG-036389,SupportServicesEnd=17_February_2024_[v2]_MTcwODEyODAwMDAwMA==0042b5603ebbc990e0777d4bf830d604";
